import { Button, Col, Input, Row, Select, Space, Typography, message } from "antd"
import {
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore"
import { useEffect, useState } from "react"
import { db } from "../../../firebase/config"
import { useAuthContext } from "../../../hooks/useAuthContext"
import { useLocation, useNavigate } from "react-router-dom"
import OrderPlateSelect from "./OrderPlateSelect"
import NewArsomaPlateModal from "../../../pages/Designer/Plates/NewArsomaPlateModal"
import NewVivaPlateModal from "../../../pages/Designer/Plates/NewVivaPlateModal"
import axiosInstance from "../../../axios/axiosConfig"

const { Text, Title } = Typography
const { TextArea } = Input

export default function UpdateOrder(props) {
  const { data } = props
  //user doc
  const { user } = useAuthContext()
  //nagiation from react-router
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const listPath = pathname.includes("new-order-list")
    ? "/designer/new-order-list"
    : "/designer/order-list"
  //data states
  const [plateData, setPlateData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [knifeLoading, setKnifeLoading] = useState(false)
  const [selectedPlate, setSelectedPlate] = useState(null)
  const [designerComment, setDesignerComment] = useState("")
  const [orderName, setOrderName] = useState(null)
  const [forwardButtonDisabled, setForwardButtonDisabled] = useState(true)

  //selectedKnife
  const [selectedKnife, setSelectedKnife] = useState({})

  //changes that has been made
  const [changesMade, setChangesMade] = useState(null)

  //last code
  const [lastCode, setLastCode] = useState(0)

  //state from location
  const state = props.data && props.data
  const machine = state?.selectedProduct.machine

  //disable forward
  useEffect(() => {
    // Check the knifeCode inside props.data.selectedProduct
    if (
      props?.data?.selectedProduct?.knifeCode === "New Knife" ||
      props?.data?.selectedProduct?.knifeCode === "none"
    ) {
      setForwardButtonDisabled(true) // ...disable the button.
    } else {
      setForwardButtonDisabled(false) // ...otherwise, enable it.
    }
    // This effect should only re-run when props.data changes
  }, [props.data])

  //fetches knife
  useEffect(() => {
    if (data) {
      const controller = new AbortController() // 1. Create a controller
      const signal = controller.signal // 2. Get its signal

      const fetchData = async () => {
        setKnifeLoading(true)
        try {
          const response = await axiosInstance.get(
            `/api/searchByCode?code=${encodeURIComponent(data.selectedProduct.knifeCode)}`,
            { signal } // 3. Pass the signal to axios
          )

          if (response.data && Object.keys(response.data).length > 0) {
            setSelectedKnife(response.data)
          } else {
            setSelectedKnife({
              gapRaport: 0,
              code: "new knife",
              height: 0,
              rowss: 0,
              spaceBetweenRows: 0,
              Form_Rows: 0,
              id: "none",
            })
          }
        } catch (error) {
          if (error.name !== "CanceledError") {
            // Don't log cancellation errors
            console.error("Failed to fetch data:", error)
          }
        } finally {
          setKnifeLoading(false)
        }
      }

      fetchData()

      // 4. Cleanup function to abort the request if the component unmounts
      return () => {
        controller.abort()
      }
    }
  }, [data])

  useEffect(() => {
    // Check if state is available
    if (state) {
      // Set loading
      setLoading(true)
      let ref = null

      // Check which machine is selected
      if (machine === "Arsoma") {
        ref = query(collection(db, "arsomaPlateList"), orderBy("codeNumber", "desc"))
      } else if (machine === "Viva") {
        ref = query(collection(db, "vivaPlateList"), orderBy("codeNumber", "desc"))
      }

      const unsubscribe = onSnapshot(ref, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ ...doc.data(), id: doc.id })
        })

        // Update state with plate data
        setPlateData(results)

        //sets last code
        setLastCode(results[0])

        // Set loading to false
        setLoading(false)
      })

      return () => unsubscribe()
    }
  }, [state, machine])

  //sets selected plate
  const onChange = (value, option, label) => {
    console.log(option)
    setSelectedPlate(option)
  }

  //updates disabled buttons
  // useEffect(() => {
  //   if (machine !== "Viva" || machine !== "Cutter") {
  //     if (selectedPlate) {
  //       if (
  //         selectedPlate.plateLocation === "Not Ordered" ||
  //         selectedPlate.plateLocation === "Visvaldis"
  //       ) {
  //         setForwardButtonDisabled(true)
  //       } else {
  //         setForwardButtonDisabled(false)
  //       }
  //     }
  //   } else {
  //     setForwardButtonDisabled(false)
  //   }
  // }, [selectedPlate, machine])

  //compares between the new price and old price
  //checks the two objects, and hides "worker and electricity"
  //also removes camel case and adds space
  useEffect(() => {
    const compareObjects = (obj1, obj2) => {
      const changedKeys = []
      const compare = (obj1, obj2, parentKey = "") => {
        for (const key in obj1) {
          const value1 = obj1[key]
          const value2 = obj2[key]

          if (typeof value1 === "object" && typeof value2 === "object") {
            compare(value1, value2, `${parentKey}${key}.`)
          } else if (value1 !== value2) {
            const changedKey = `${parentKey}${key}`
            const keyWithoutPath = changedKey.substring(changedKey.lastIndexOf(".") + 1)
            const modifiedKey = keyWithoutPath
              .replace(/([a-z])([A-Z])/g, "$1 $2")
              .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
              .toLowerCase()

            // Exclude specific keys from being added to changedKeys
            if (
              modifiedKey !== "worker" &&
              modifiedKey !== "electricity" &&
              modifiedKey !== "knife id"
            ) {
              changedKeys.push({
                key: modifiedKey,
                oldValue: value1,
                newValue: value2,
              })
            }
          }
        }
      }
      compare(obj1, obj2)
      return changedKeys
    }

    const changedKeys = compareObjects(props.data, props.oldOrderData)
    setChangesMade(changedKeys) //sets the changes made into state
  }, [props.data, props.oldOrderData])

  const handleUpload = async (orderStatus) => {
    const docRef = doc(db, "orders", state.id)

    if (orderStatus === 0) {
      try {
        await updateDoc(docRef, {
          ...props.data,
          technicalPage: props.data.selectedProduct.technicalPage,
          orderName: orderName,
          designerComment: designerComment,
          selectedPlate: selectedPlate,
          updatedBy: user.uid,
          updatedByEmail: user.email,
          updated: serverTimestamp(),
          updatedByDesigner: serverTimestamp(),
          orderForAdmin: false,
          orderReviewFromAdmin: false,
          orderStatus: orderStatus,
          changesByDesigner: changesMade, //changes made by designer
          changedByDesigner: true,
          selectedProduct: state?.selectedProduct, //updated order from data
        })
        message.success("Document updated")
        setChangesMade(null) // <-- Use semicolon here
        navigate(listPath) // <-- Use semicolon here
      } catch (error) {
        message.error(error.message)
        setChangesMade(null) // <-- Use semicolon here
        navigate(listPath) // <-- Use semicolon here
      }
    } else {
      try {
        await updateDoc(docRef, {
          ...props.data,
          technicalPage: props.data.selectedProduct.technicalPage,
          orderName: orderName,
          designerComment: designerComment,
          selectedPlate: selectedPlate,
          updatedBy: user.uid,
          updatedByEmail: user.email,
          updated: serverTimestamp(),
          orderStatus: orderStatus,
        })
        message.success("Document updated")
        setChangesMade(null) // <-- Use semicolon here
        navigate(listPath) // <-- Use semicolon here
      } catch (error) {
        message.error(error.message)
        setChangesMade(null) // <-- Use semicolon here
        navigate(listPath) // <-- Use semicolon here
      }
    }
  }

  //handles plate
  const handlePlateLocation = async (value) => {
    let plateRef
    //checks where to update
    if (machine === "Arsoma" && selectedPlate != null) {
      plateRef = doc(db, "arsomaPlateList", selectedPlate.id)
    } else if (machine === "Viva" && selectedPlate != null) {
      plateRef = doc(db, "vivaPlateList", selectedPlate.id)
    } else {
      return message.error("select plate first!")
    }
    try {
      await updateDoc(plateRef, {
        plateLocation: value,
      }).then(() => {
        message.success("Location updated")
        setSelectedPlate((prevSelectedPlate) => ({
          ...prevSelectedPlate,
          plateLocation: value,
        }))
      })
    } catch (error) {
      message.error(error.message)
    }
  }

  //return correct newPlate selection
  const newPlateSelection = () => {
    if (machine === "Arsoma") {
      return (
        <NewArsomaPlateModal
          comingFromOrderDetails={true}
          dataDetails={state}
          selectedKnife={selectedKnife}
          lastPlate={lastCode}
        />
      )
    } else {
      return (
        <NewVivaPlateModal
          comingFromOrderDetails={true}
          dataDetails={state}
          selectedKnife={selectedKnife}
          lastPlate={lastCode}
          onPlateCreated={(plate) => setSelectedPlate(plate)}
        />
      )
    }
  }

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <Title level={4}>Designer Details</Title>
        </Col>
        <Col span={8}>
          <Space>
            <Text>Custom Order Name</Text>
            <Input
              style={{ width: "100%" }}
              onChange={(event) => setOrderName(event.target.value)}
            />
          </Space>
        </Col>
        <Col span={8}>
          <Space>
            <Text>Select Plate</Text>
            <Select
              showSearch
              placeholder="Select Plate"
              optionFilterProp="children"
              onChange={onChange}
              loading={loading}
              value={selectedPlate && selectedPlate.code}
              filterOption={(input, option) =>
                option.code.toLowerCase().includes(input.toLowerCase())
              }
              filterSort={(optionA, optionB) =>
                optionA.code.toLowerCase().localeCompare(optionB.code.toLowerCase())
              }
              options={plateData}
              style={{ width: 250 }}
              fieldNames={{ label: "code", value: "code" }}
            />
            <OrderPlateSelect
              loading={loading}
              selectedPlate={selectedPlate && selectedPlate}
              plateData={plateData && plateData}
              setSelectedPlate={setSelectedPlate}
            />
            {newPlateSelection()}
          </Space>
        </Col>
        <Col span={8}>
          <Space>
            <Text>Plate Location</Text>
            <Select
              style={{ width: 200 }}
              value={selectedPlate && selectedPlate.plateLocation}
              onChange={handlePlateLocation}
              options={[
                {
                  value: "Not Ordered",
                  label: "Not Ordered",
                },
                {
                  value: "Ordered",
                  label: "Ordered (in proccess)",
                },
                {
                  value: "Kengarags",
                  label: "At Kengarags",
                },
                {
                  value: "Visvaldis",
                  label: "At Visvaldis",
                },
              ]}
            />
          </Space>
        </Col>
        <Col span={24}>
          <Text>Designer comment</Text>
          <TextArea
            rows={6}
            value={designerComment}
            onChange={(event) => setDesignerComment(event.target.value)}
          />
        </Col>
        <Col span={24}>
          <Space direction="vertical">
            <Button loading={knifeLoading} type="primary" onClick={() => handleUpload(1)}>
              Just update
            </Button>
            <Button
              disabled={forwardButtonDisabled}
              loading={knifeLoading}
              onClick={() => handleUpload(2)}>
              Update & Send Forward
            </Button>
            <Button loading={knifeLoading} onClick={() => handleUpload(0)} danger type="primary">
              Send back to manager
            </Button>
          </Space>
        </Col>
      </Row>
    </>
  )
}
